module.exports = __webpack_public_path__ + "sv.svg?abfac59c5ed910b2ddc7cc545c45cb17";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sv.svg
// module id = 1628
// module chunks = 0